<div [@pageTransition]>
  <p>events works!</p>

  <button class="btn btn-primary" (click)="loadTest()">Click Me</button>
</div>

<router-outlet name="test"></router-outlet>